// ===== ANONYMOUS AI v25.0 QUANTUM - WEB SEARCH HOOK =====

import { useState, useCallback } from 'react';
import webSearchService from '../services/webSearchService';

export const useWebSearch = () => {
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState(null);
  const [searchError, setSearchError] = useState(null);

  const search = useCallback(async (query, options = {}) => {
    setIsSearching(true);
    setSearchError(null);
    
    try {
      const results = await webSearchService.search(query, options);
      setSearchResults(results);
      return results;
    } catch (error) {
      setSearchError(error.message);
      console.error('Search failed:', error);
      return null;
    } finally {
      setIsSearching(false);
    }
  }, []);

  const searchAndSummarize = useCallback(async (query, apiCallFunction) => {
    setIsSearching(true);
    setSearchError(null);
    
    try {
      const result = await webSearchService.searchAndSummarize(query, apiCallFunction);
      return result;
    } catch (error) {
      setSearchError(error.message);
      console.error('Search and summarize failed:', error);
      return null;
    } finally {
      setIsSearching(false);
    }
  }, []);

  const clearResults = useCallback(() => {
    setSearchResults(null);
    setSearchError(null);
  }, []);

  return {
    search,
    searchAndSummarize,
    clearResults,
    isSearching,
    searchResults,
    searchError
  };
};
